/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useParams, useLocation, Link } from "react-router-dom";
import { authenticationService } from "../service/authentication";
import CustomToast from "../widgets/toaster";
import { MdErrorOutline } from "react-icons/md";
import logo from "../assets/images/empats_logo.png";


// import './signin.css'

const ResetPassword = (userDetails: any) => {
  const [newPassword, setnewPassword] = useState("");
  const [confirmPassword, setconfirmPassword] = useState("");
  const [password, setPassword] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("");
  const [authToken , setAuthToken] = useState("");
  const [authUserID , setAuthUserID] = useState("");
  const [userId, setUserId] = useState("");
  const [resetFlg, setResetFlg] = useState(0);


  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const username: any = queryParams.get("username");
  // const password: any = queryParams.get("password");


  const passwordsMatch = newPassword === confirmPassword;

  useEffect(() => {
    var storedData = localStorage.getItem('loginDetails');
    if(storedData) {
      var storedObject = JSON.parse(storedData);
      setAuthToken(storedObject[0].x_auth_token);
      setAuthUserID(storedObject[0].x_userid);
      setUserId(storedObject[0].id);
      setResetFlg(storedObject[0].reset_flg);
    }
  }, [])

  const handleNewPassword = (event: React.ChangeEvent<HTMLInputElement>) => {
    setnewPassword(event.target.value);
  };

  const handlePassword = (event: React.ChangeEvent<HTMLInputElement>) => {
      setPassword(event.target.value);
  };

  const handleconfirmPassword = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setconfirmPassword(event.target.value);
  };

  const canLogin =
    password !== "" || (confirmPassword !== "" && password == confirmPassword);

   // Validate password
   const validatePassword = (password : any) => {
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#%^&*])(?=.{8,})/;
    return regex.test(password);
  };

  const handleLogOut =  async (userId : any, authToken: any, authUserID: any) => {
    try {
      const response = await authenticationService.LogoutApi(userId, authToken, authUserID);
      if (response.status && response.statusCode === 200) {
        localStorage.removeItem('userDetails');
        localStorage.removeItem('loginDetails');
      }
    } catch (error) {
      console.error("Error signing in:", error);
    }
  }

  const handleUpdateBtn = async () => {
    if(passwordsMatch && validatePassword(newPassword) && validatePassword(confirmPassword)) {
      try {
        const response = await authenticationService.changePassword(
          username,
          password,
          newPassword,
          confirmPassword
        );
        if (response.status && response.statusCode === 200) {
          setToastType("success")
          setToastMessage(response.message)
          setShowToast(true)
          setTimeout(() => {
            if(resetFlg === 1) {   
              handleLogOut(authUserID, authToken, authUserID)
            } else {
              handleLogOut(userId, authToken, authUserID)
            }
            navigate("/");
          }, 4000); // Delay 4 second to let toast show
        }else{
          setToastType("error")
          setToastMessage(response.message)
          setShowToast(true)
        }
        
      } catch (error) {
        console.error("Error signing in:", error);
      }
    } else {
      console.log("invalid pass")
    }
  };

  return (
    <div className="signinBg">
      <CustomToast
        show={showToast}
        onClose={() => setShowToast(false)}
        delay={5000}
        message={toastMessage}
        toastType={toastType}
      />
      
      <div className="loginInputArea">
        <div className="signinBrandArea">
          <img src={logo} alt="Zent EM Logo" className="brandLogo" />
        </div>
        
        <div className="formGroup input-login">
          <label htmlFor="password" className="login-label">
            Current Password
          </label>
          <input
            type="password"
            placeholder="Current Password"
            className="form-control custom-input"
            id="password"
            value={password}
            onChange={handlePassword}
          />
        </div>
        
        <div className="formGroup input-password">
          <label htmlFor="new-password" className="login-label">
            New Password
          </label>
          <input
            type="password"
            placeholder="New Password"
            className="form-control custom-input"
            id="new-password"
            value={newPassword}
            onChange={handleNewPassword}
          />
          <div style={{ color: "yellow", fontSize: "12px", fontWeight: "600" }} title=" Password must be at least 8 characters, include an uppercase letter, a lowercase letter, a number, and a symbol (!,@,#,%,^,&,*).">
            {newPassword && !validatePassword(newPassword) && (
              "*Password criteria doesn`t meet"
            )}
          </div>
        </div>
        
        <div className="formGroup input-password">
          <label htmlFor="confirm-password" className="login-label">
            Confirm Password
          </label>
          <input
            type="password"
            placeholder="Confirm Password"
            className="form-control custom-input"
            id="confirm-password"
            value={confirmPassword}
            onChange={handleconfirmPassword}
          />
          {!passwordsMatch && (
            <p style={{ color: "yellow", fontSize: "12px", fontWeight: "600" }} className="my-2">
              * Password does not match
            </p>
          )}
          <div style={{ color: "yellow", fontSize: "12px", fontWeight: "600" }} title=" Password must be at least 8 characters, include an uppercase letter, a lowercase letter, a number, and a symbol (!,@,#,%,^,&,*).">
            {confirmPassword && !validatePassword(confirmPassword) && (
              "*Password criteria doesn`t meet"
            )}
          </div>
        </div>
        
        {canLogin ? (
          <button
            onClick={() => handleUpdateBtn()}
            type="button"
            className="signinBtn2"
          >
            RESET PASSWORD
          </button>
        ) : (
          <button type="button" className="signinBtn1">
            RESET PASSWORD
          </button>
        )}
        
        <div className="login-indicator"></div>
        
        <p className="text-center mt-3" style={{ color: "white" }}>
          <Link to="/adminDashboard" style={{ color: "#FF7344", textDecoration: "none" }}>
            Cancel
          </Link>
        </p>
      </div>
    </div>
  );
};

export default ResetPassword;
